var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEventApi } from './useEvent/useEventApi';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { transformDecoratedEventToUpdate } from '../utils/payloadBuilders';
import { RRule } from 'rrule';
/* This hook is used to create the event we'll manage in the event composer
  It fetches an event in edit mode and and spaces.
*/
export function useInitializeEventToEdit(_a) {
    var _this = this;
    var timezone = _a.timezone, eventId = _a.eventId, onError = _a.onError, tenantId = _a.tenantId, apiUrl = _a.apiUrl, baseApiUrl = _a.baseApiUrl, currentOrg = _a.currentOrg, accessToken = _a.accessToken;
    var t = useTranslation('meetingRooms').t;
    var _b = useEventApi({
        onError: onError,
        apiUrl: apiUrl,
        baseApiUrl: baseApiUrl,
        currentOrg: currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }), fetchEvent = _b.fetchEvent, fetchEventSeries = _b.fetchEventSeries;
    var _c = __read(useState(null), 2), eventData = _c[0], setEventData = _c[1];
    var _d = __read(useState(false), 2), fetchingEvent = _d[0], setFetchingEvent = _d[1];
    var _e = __read(useState(null), 2), errorFetchingEventMessage = _e[0], setErrorFetchingEventMessage = _e[1];
    var handleFetchEventSeries = useCallback(function (seriesId) { return __awaiter(_this, void 0, void 0, function () {
        var eventSeries, rruleString;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!seriesId)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, fetchEventSeries(seriesId)];
                case 1:
                    eventSeries = _b.sent();
                    rruleString = (_a = eventSeries === null || eventSeries === void 0 ? void 0 : eventSeries.recurrence) === null || _a === void 0 ? void 0 : _a[0];
                    if (rruleString) {
                        return [2 /*return*/, RRule.fromString(rruleString)];
                    }
                    return [2 /*return*/, null];
            }
        });
    }); }, [fetchEventSeries]);
    useEffect(function () {
        var aborted = false;
        setFetchingEvent(true);
        fetchEvent({ id: eventId, timezone: timezone })
            .then(function (event) { return __awaiter(_this, void 0, void 0, function () {
            var recurrenceRule, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!event) {
                            if (!aborted) {
                                setErrorFetchingEventMessage(t('errors.event_not_found', { eventId: eventId }));
                            }
                            return [2 /*return*/];
                        }
                        if (aborted)
                            return [2 /*return*/];
                        recurrenceRule = null;
                        if (!event.series_id) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, handleFetchEventSeries(event.series_id)];
                    case 2:
                        recurrenceRule = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        recurrenceRule = null;
                        return [3 /*break*/, 4];
                    case 4:
                        if (aborted)
                            return [2 /*return*/];
                        setEventData(__assign(__assign({}, event), { recurrenceRule: recurrenceRule }));
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            setErrorFetchingEventMessage(t('errors.failed_to_fetch_event', { error: error.message }));
        })
            .finally(function () {
            setFetchingEvent(false);
        });
        return function () {
            aborted = true;
            setFetchingEvent(false);
            setErrorFetchingEventMessage(null);
        };
    }, [eventId, timezone, fetchEvent, handleFetchEventSeries, t]);
    var eventToBeUpdated = useMemo(function () {
        if (eventData) {
            return transformDecoratedEventToUpdate(eventData);
        }
        return undefined;
    }, [eventData]);
    return {
        fetchingEvent: fetchingEvent,
        errorFetchingEventMessage: errorFetchingEventMessage,
        eventToBeUpdated: eventToBeUpdated,
    };
}
